<template>
  <div class="price_tab_three_container warp" style="width: 1200px !important;">
    <h2 class="tab_title" data-aos="fade-down" data-aos-delay="50">
      功能服务说明
    </h2>
    <div class="tab_content">
      <div class="tab_content_item" v-for="item in dataList">
        <div class="tab_content_item_top">
          <img :src="item.icon" />
          <h3>{{ item.title }}</h3>
          <span>{{ item.subTitle }}</span>
        </div>
        <div
          class="tab_content_item_bottom"
          v-for="(node, index) in item.subList"
          :class="{ hasBorder: index === item.subList.length - 1 }"
        >
          <div class="tab_content_item_left">
            <strong>{{ node.title }}</strong>
            <div>{{ node.subTitle }}</div>
          </div>
          <p class="tab_content_item_right" v-html="node.desc"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import img1 from "@/assets/price/营销管理.png";
import img2 from "@/assets/price/推广引流.png";
import img3 from "@/assets/price/快速获客.png";
import img4 from "@/assets/price/客户管理.png";
import img5 from "@/assets/price/服务支持.png";

export default {
  components: {},
  data() {
    return {
      dataList: [
        {
          icon: img1,
          title: "营销管理",
          subTitle: "智能辅助、内容生成",
          subList: [
            {
              title: "基础功能",
              subTitle: "团队管理工具",
              desc: "团队管理、角色权限、公司文件、消息提醒等",
            },
            {
              title: "智能助手",
              subTitle: "智能辅助工具",
              desc: "智能专业对话、智能绘画设计、智能应用市场等 ",
            },
            {
              title: "营销内容",
              subTitle: "AI生成内容+内容管理",
              desc:
                "公司品牌信息、产品管理、营销主题、动态文章、常见问题解答(FAQ)、营销话术、售后服务信息、案例评价及应用场景、关键词库、 营销设置等 ",
            },
            {
              title: "经验策略",
              subTitle: "决策辅助工具",
              desc:
                "营销经验、目标市场、目标受众、营销策略、相关资讯、竞品管理、营销分析等",
            },
          ],
        },
        {
          icon: img2,
          title: "推广引流",
          subTitle: "品牌推广、获客引流、智能营销",
          subList: [
            {
              title: "智能建站",
              subTitle: "搜索引擎优化SEO",
              desc:
                "品牌独立站、多站站群技术、智能生成网站、智能SEO优化、网站数据分析优化等",
            },
            {
              title: "社媒营销",
              subTitle: "Facebook、LinkedIn",
              desc: "Facebook、LinkedIn、主页管理、发帖、回复等",
            },
            {
              title: "智能推广",
              subTitle: "独立站、站群、Facebook、Linkedin",
              desc: "自动生成发布计划、创作文章、发布文章动态等 ",
            },
            {
              title: "智能客服",
              subTitle: "独立站、Facebook、Linkedin",
              desc: "专有知识库、智能沟通回复、智能提取询盘、24小时在线等",
            },
            {
              title: "邮件营销EDM",
              subTitle: "智能收发、自动执行",
              desc: "高智商高情商AI、丰富邮件模板、多语言沟通回复、及时提醒等",
            },
          ],
        },
        {
          icon: img3,
          title: "快速获客",
          subTitle: "监控提醒、客户查询、智能匹配",
          subList: [
            {
              title: "商机监控",
              subTitle: "自动发现和提醒",
              desc: "监控全球热门社交媒体有效商机",
            },
            {
              title: "客户搜索",
              subTitle: "直接搜索客户",
              desc: "海关数据、全球买家、联系人邮箱等数据查询",
            },
            {
              title: "查询工具",
              subTitle: "整合多种搜索渠道",
              desc: "Google搜索、Google地图、Facebook搜索和LinkedIn搜索",
            },
            {
              title: "智能推荐",
              subTitle: "自动搜索匹配推荐客户",
              desc: "通过搜索引擎、网站、社交媒体和多数据源匹配推荐",
            },
            {
              title: "数据完善",
              subTitle: "自动查找匹配完善",
              desc:
                "提供线索，自动通过搜索引、社交媒体、资讯内容和数据源等完善各种客户数据",
            },
          ],
        },
        {
          icon: img4,
          title: "客户管理",
          subTitle: "客户安全、高效管理、智能营销",
          subList: [
            {
              title: "客户筛选分配",
              desc: "客户筛选、分类、分配",
            },
            {
              title: "线索管理培育",
              desc: "客户线索管理、联系沟通、信息完善、意向培育",
            },
            {
              title: "商机管理开发",
              desc: "客户管理、沟通谈判、报价、下单、成交跟进等",
            },
            {
              title: "售后服务支持",
              desc: "售后管理、问题解答、满意度、客情维护、复购",
            },
            {
              title: "通讯工具方式",
              desc: "邮件、电话和WhatsApp等",
            },
            {
              title: "智能客户跟进",
              desc: "智能自动化跟进筛选培育意向客户",
            },
          ],
        },
        {
          icon: img5,
          title: "服务支持",
          subTitle: "优质服务保障",
          subList: [
            {
              title: "基础文档培训",
              desc:
                "<div style='width: 100%'>提供详细的系统操作指南，包括<strong>文字文档</strong>和<strong>视频教程</strong>，同时提供系统<strong>使用培训</strong>。帮助用户快速上手和深度理解系统功能，从基础设置到高级操作，全方位覆盖，确保用户在使用过程中能够自如应对各种情景，提升工作效率。</div>",
            },
            {
              title: "辅助支持实施",
              desc:
                "我们提供系统初始化设置、资料素材处理和生成、网站建站、账号配置等工作。用户可随时咨询，获得技术团队的实时帮助，确保系统顺利实施和运行，大大减少因系统不熟悉而导致的操作困难和工作中断。",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="sass" scoped>
.price_tab_three_container {
  padding-bottom: 60px;
.tab_title {
  font-weight: 500;
font-size: 42px;
color: #111111;
text-align: center;
margin: 105px 0 40px 0;
  }
    .tab_content {
.tab_content_item {
  .tab_content_item_top {
    height: 79px;
background: #E6F0FF;
display: flex;
align-items: center;
column-gap: 10px;
padding: 0 20px;
div,h3 {
  font-weight: 500;
font-size: 24px;
color: #111111;
  }
    span {
      font-size: 18px;
color: #111111;
      }
        img {
          width: 32px;
          }
    }
    .hasBorder {
          border-bottom: 1px solid #E4E4E5;
          }
      .tab_content_item_bottom {
        display: flex;
        height: 88px;
        align-items: center;

        .tab_content_item_left {
          width: 315px;
          height: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          padding-left: 40px;
          font-size: 14px;
          color: #666;
          border-top: 1px solid #E4E4E5;
          border-right: 1px solid #E4E4E5;
          border-left: 1px solid #E4E4E5;
          strong {
            font-size: 16px;
            color: #333;
            }
          }
            .tab_content_item_right {
              flex: auto;
              height: 100%;
              padding-left: 75px;
              display: flex;
              color: #222222;
              font-size: 16px;
              align-items: center;
              border-top: 1px solid #E4E4E5;
          border-right: 1px solid #E4E4E5;
          line-height: 29px;
          margin-bottom: 0px;

              }
        }
  }
      }
  }
</style>
